import React, { useEffect, useRef, useState } from "react";
import { Zap } from "lucide-react";
import { toast } from "sonner";

const Breath = ({ game, level, lang, onFinish }) => {
  const lvl = game.levels[level - 1] || {};
  const rounds = lvl.rounds || game.data.rounds;
  const inhale = lvl.inhale || game.data.inhale;
  const exhale = lvl.exhale || game.data.exhale;
  const pointsPerLevel = lvl.points || game.points;

  const [round, setRound] = useState(1);
  const [phase, setPhase] = useState("inhale");
  const [phaseTime, setPhaseTime] = useState(0);
  const [score, setScore] = useState(0);
  const phaseDuration = phase === "inhale" ? inhale : exhale;
  const tappedThisPhase = useRef(false);

  useEffect(() => {
    const t = setInterval(() => {
      setPhaseTime((s) => {
        if (s + 0.1 >= phaseDuration) {
          if (phase === "exhale") {
            const nextRound = round + 1;
            if (nextRound > rounds) {
              clearInterval(t);
              const earned = Math.round((score / rounds) * pointsPerLevel);
              setTimeout(() => onFinish({ score, points: earned, total: rounds }), 50);
              return 0;
            }
            setRound(nextRound);
          }
          setPhase((p) => (p === "inhale" ? "exhale" : "inhale"));
          tappedThisPhase.current = false;
          return 0;
        }
        return s + 0.1;
      });
    }, 100);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [phase, round]);

  const tap = () => {
    const sweetSpot =
      phase === "inhale"
        ? phaseTime >= phaseDuration - 0.6
        : phaseTime >= phaseDuration - 0.8;
    if (sweetSpot && !tappedThisPhase.current) {
      tappedThisPhase.current = true;
      setScore((s) => s + 1);
      toast.success(lang === "es" ? "¡Justo a tiempo!" : "Right on time!");
    }
  };

  const progress = (phaseTime / phaseDuration) * 100;
  const ringSize = phase === "inhale" ? 40 + progress * 1.2 : 160 - progress * 1.2;

  return (
    <div data-testid={`game-breath-${game.id}`} className="text-center">
      <div className="flex justify-between text-sm mb-3">
        <span className="bs-amber font-bold">
          {lang === "es" ? "Ronda" : "Round"}: {round}/{rounds}
        </span>
        <span className="bs-amber font-bold">
          {lang === "es" ? "Aciertos" : "Score"}: {score}
        </span>
      </div>
      <p className="bs-muted text-sm mb-3">
        {lang === "es"
          ? "Toca la ola en lo alto / lo bajo"
          : "Tap at the wave peak / bottom"}
      </p>
      <div className="h-56 flex items-center justify-center">
        <div
          className="rounded-full bg-gradient-to-br from-blue-400/40 to-cyan-300/40 border-2 border-blue-300/50 transition-all"
          style={{
            width: `${ringSize}px`,
            height: `${ringSize}px`,
            transitionDuration: "120ms",
          }}
        />
      </div>
      <p className="bs-title font-extrabold text-2xl mb-4">
        {phase === "inhale"
          ? lang === "es"
            ? "Inhala"
            : "Inhale"
          : lang === "es"
          ? "Exhala"
          : "Exhale"}
      </p>
      <button onClick={tap} className="bs-cta justify-center w-full sm:w-auto" data-testid="breath-tap">
        <Zap className="w-4 h-4" /> Tap!
      </button>
    </div>
  );
};

export default Breath;
